var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vuejs-uploader",
      class: {
        "vuejs-uploader--dragged": _vm.isDraggedOver && !_vm.isBrowseDisabled,
      },
      on: {
        drop: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.dropFiles.apply(null, arguments)
        },
        dragover: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.dragover.apply(null, arguments)
        },
        dragleave: _vm.dragleave,
      },
    },
    [
      _c("label", { class: { disabled: _vm.isBrowseDisabled } }, [
        _vm.isSingleFileUpload
          ? _c(
              "span",
              [
                _vm._t("browse-btn", function () {
                  return [
                    _c("span", { staticClass: "vuejs-uploader__btn" }, [
                      _vm._v("Browse"),
                    ]),
                  ]
                }),
                _vm._v(" "),
                _vm.files[0] && _vm.hasError(_vm.files[0]) && _vm.showErrors
                  ? _c("p", { staticClass: "vuejs-uploader__error" }, [
                      _vm._v(_vm._s(_vm.handleError(_vm.files[0].error))),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showProgressBar && _vm.files[0]
                  ? _c("div", { staticClass: "vuejs-uploader__progress" }, [
                      _c("div", {
                        staticClass: "vuejs-uploader__progress-bar",
                        style: _vm.progressBarStyle(_vm.files[0]),
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "vuejs-uploader__progress-bar-text" },
                        [_vm._v(_vm._s(_vm.progressBarText(_vm.files[0])))]
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isMultipleFileUpload
          ? _c(
              "span",
              [
                _vm._t("browse-btn", function () {
                  return [
                    _c("span", { staticClass: "vuejs-uploader__btn" }, [
                      _vm._v("Browse"),
                    ]),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          attrs: {
            type: "file",
            disabled: _vm.isBrowseDisabled,
            multiple: _vm.multiple,
            accept: _vm.accept,
          },
          on: { change: _vm.selectFiles },
        }),
      ]),
      _vm._v(" "),
      _vm.isMultipleFileUpload
        ? _c("span", [
            _c(
              "button",
              {
                staticClass: "vuejs-uploader__btn vuejs-uploader__btn--clear",
                attrs: { type: "button", disabled: _vm.noFiles },
                on: { click: _vm.clear },
              },
              [
                _vm._t("clear-btn", function () {
                  return [_vm._v("Clear")]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "vuejs-uploader__btn vuejs-uploader__btn--upload",
                class: { "vuejs-uploader__btn--ready": _vm.hasFiles },
                attrs: { type: "button", disabled: _vm.isUploadDisabled },
                on: { click: _vm.upload },
              },
              [
                _vm._t("upload-btn", function () {
                  return [_vm._v("Upload")]
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("div", { staticClass: "vuejs-uploader__error" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isMultipleFileUpload
        ? _c(
            "ul",
            { staticClass: "vuejs-uploader__queue" },
            _vm._l(this.files, function (fileObj, i) {
              return _c("li", { key: i, staticClass: "vuejs-uploader__file" }, [
                _c("div", { staticClass: "vuejs-uploader__file--preview" }, [
                  _vm.isImageUpload(fileObj) && !fileObj.image
                    ? _c("div", { staticClass: "loading" })
                    : _vm._e(),
                  _vm._v(" "),
                  fileObj.image
                    ? _c("img", { attrs: { src: fileObj.image } })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isImageUpload(fileObj)
                    ? _c(
                        "span",
                        {
                          staticClass: "vuejs-uploader__file-icon",
                          class: fileObj.extension,
                        },
                        [_vm._v(_vm._s(fileObj.extension))]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vuejs-uploader__file--meta" },
                  [
                    _c("p", { staticClass: "vuejs-uploader__file--filename" }, [
                      _vm._v(_vm._s(fileObj.file.name)),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "vuejs-uploader__file--filesize" }, [
                      _vm._v(_vm._s(fileObj.formattedFilesize)),
                    ]),
                    _vm._v(" "),
                    fileObj.error && _vm.showErrors
                      ? _c("p", [
                          _vm._v(_vm._s(_vm.handleError(fileObj.error))),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._t("extra", null, { fileObj: fileObj }),
                    _vm._v(" "),
                    _c("div", { staticClass: "vuejs-uploader__progress" }, [
                      _c("div", {
                        staticClass: "vuejs-uploader__progress-bar",
                        style: _vm.progressBarStyle(fileObj),
                      }),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass:
                        "vuejs-uploader__btn vuejs-uploader__btn--delete",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.removeFile(fileObj)
                        },
                      },
                    },
                    [
                      _vm._t("remove-btn", function () {
                        return [_vm._v("Remove")]
                      }),
                    ],
                    2
                  ),
                ]),
              ])
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }